import { createSlice } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"

const initialState = {
  snackbar: { open: false, message: "", type: "success" },
}
export const snackbarSlice = createSlice({
  name: "snackbar",
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      return {
        ...state,
        snackbar: action.payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})
export const { showSnackbar } = snackbarSlice.actions
export const snackbarData = (state) => {
  return state.snackbar.snackbar
}
export const snackbarReducer = snackbarSlice.reducer
